document.querySelector('.btn-add').addEventListener('click', () => {

    let name = document.querySelector('.product [data-name]').dataset.name
    let price = document.querySelector('.product [data-price]').dataset.price
    let brand = document.querySelector('.product [data-brand]').dataset.brand
    let category = document.querySelector('.product [data-category]').dataset.category
    let index = document.querySelector('.product [data-id]').dataset.id
    let quantity = document.querySelector('.product [data-quantity]').dataset.quantity


    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
            'items': [{
                'item_name': name,
                'price': price,
                'item_brand': brand,
                'item_category': category,
                'item_list_name': '',
                'index': index,
                'quantity': quantity
            }]
        }
    });

    fbq('track', 'AddToCart', {
        value: price,
        currency: "UAH",
        content_type: 'product',
        content_ids: index
    });
})